import { CustomerMsisdnNotificationPaginatorInterface } from '../../models/customer-msisdn-notification-paginator.interface';

export interface MsisdnNotificationsInterfaceState {
  result: CustomerMsisdnNotificationPaginatorInterface;
}

export const initialMsisdnNotificationsState: MsisdnNotificationsInterfaceState = {
  result: null
};
